import { render, staticRenderFns } from "./ApplicantInformation.vue?vue&type=template&id=461ab55b&scoped=true"
import script from "./ApplicantInformation.vue?vue&type=script&lang=js"
export * from "./ApplicantInformation.vue?vue&type=script&lang=js"
import style0 from "./ApplicantInformation.vue?vue&type=style&index=0&id=461ab55b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ab55b",
  null
  
)

export default component.exports